import type { InitialState } from '@Hooks/modalManager/modal.types.ts';

type SetModal = (config: Partial<InitialState>) => void;

let modalSetterRef: SetModal | null = null;

export const registerModalSetter = (setter: SetModal | null) => {
  modalSetterRef = setter;
};

export const getModalSetter = (): SetModal | null => {
  return modalSetterRef;
};
